<template>
  <div>
    <div class="chart-display" :class="{'is-visible': showIntroBox}">
      <chart-view :chartOption="currentOption" height="100%" width="100%" ref="hbNGChart"></chart-view>
      <div class="intro-text">
        <span>
          {{chartData[intervalNum%chartData.length].description}}
        </span>
      </div>
      <div class="intro-close">
        <i class="el-icon-close" @click="hideIntro"></i>
      </div>
      <div class="intro-process">
        <ul>
          <li v-for="(_, index) in chartData" :key="index" @click="changeIntervalNum(index)"
          :class="{'activate': index===intervalNum%chartData.length}">
            <i class="el-icon-s-opportunity"></i>
          </li>
        </ul>
      </div>
      <div class="intro-pause">
        <i :class="{'el-icon-video-pause':!pauseState,'el-icon-video-play':pauseState}" @click="pauseState=!pauseState"></i>
      </div>
    </div>
    <div class="centerbg">
      <div class="img-display" style="text-align: center;">
        <div class="home-title mb-3">
          <h2>
            <span style="color: #41ab5d;">S</span>ingle 
            <span style="color: #41ab5d;">C</span>ell 
            <span style="color: #41ab5d;">Plant </span>  
            <span style="color: #41ab5d">D</span>ata<span style="color: #41ab5d">B</span>ase</h2>
            <div class="display-intro" @click="showIntro">
              <i class="el-icon-video-play"></i>
            </div>
        </div>
        <home-hex></home-hex>
      </div>
    </div>
    <div class="content-box mx-5">
      <el-row class="mx-5 mb-3">
        <el-col :lg="14" :md="24" class="mb-5">
          <home-intro style="min-height: 380px;"></home-intro>
        </el-col>
        <el-col :lg="10" :md="24" class="mb-5">
          <div class="icon-box" style="height: 350px;">
            <div class="icon-box-row">
              <div class="statistic-icon" :key="index" :id="item.name+'_statistic'"
              v-for="(item, index) in statisData.slice(0,3)">
                <h5>{{ item.name }}</h5>
                <el-statistic group-separator="," :value="item.value"/>
              </div>
            </div>
            <div class="icon-box-row">
              <div class="statistic-icon" :key="index" :id="item.name+'_statistic'"
              v-for="(item, index) in statisData.slice(3,)">
                <h5>{{ item.name }}</h5>
                <el-statistic group-separator="," :value="item.value"/>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="mx-5">
        <home-carousel></home-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import ChartView from '@/components/echarts/main.vue'
import nightingaleChart from '@/components/echarts/options/pie/nightingaleChart'
import simpleStroke from '@/components/echarts/options/graphicstroke/simpleStroke'
import parliament from '@/components/echarts/options/custom/parliament'
import tableVerticalBar from '@/components/echarts/options/bar/tableVerticalBar'
import radiusBarPie from '@/components/echarts/options/pie/radiusBarPie_home'

import HomeIntro from './HomeIntro.vue'
import HomeCarousel from './HomeCarousel.vue'
import HomeHex from './HomeHex.vue'
import intervalData from '@/assets/json/home/home_interval.json'
import statisticData from '@/assets/json/home/home_statistic.json'

import homebg from '@/assets/img/home_bg1.jpg'

function toggleBody(isPin){
  if(isPin){
    document.body.style.height = '100vh'
    document.body.style['overflow-y'] = 'hidden'
  }else{
    document.body.style.height = 'unset'
    document.body.style['overflow-y'] = 'auto'
  }
}

export default {
  components: { ChartView, HomeIntro, HomeCarousel, HomeHex },
  data() {
    return {
      homebg: homebg,

      isActivatedFlag: false,
      showIntroBox: false,

      chartData: intervalData,
      chartOptions: [],
      intervalContainer: {},
      intervalNum: 0,
      currentOption: {},
      pauseState: false,

      statisData: statisticData
    }
  },
  created() {
    for(let item of this.chartData){
      if(item.type==="nightingaleChart"){
        this.chartOptions.push(nightingaleChart(item.data))
      }else if(item.type==="simpleStroke"){
        this.chartOptions.push(simpleStroke(item.data))
      }else if(item.type==="parliament"){
        this.chartOptions.push(parliament(item.data))
      }else if(item.type==="bar"){
        let x = item.data.map(item => item.name)
        let y = item.data.map(item => item.value)
        this.chartOptions.push(tableVerticalBar({
          x: x,
          y: y
        }))
      }else if(item.type==='pieBar'){
        this.chartOptions.push(radiusBarPie(item.data))
      }
    }
  },
  mounted() {
    this.isActivatedFlag = true;
  },
  activated() {
    this.isActivatedFlag = true;
    this.$refs.hbNGChart.myChart.resize()
  },
  deactivated() {
    this.isActivatedFlag = false;
  },
  watch: {
    pauseState: function() {
      if(this.pauseState) {
        clearInterval(this.intervalContainer)
      }else{
        this.intervalNum += 1;
          this.currentOption = this.chartOptions[this.intervalNum%this.chartOptions.length];
        this.intervalContainer = setInterval(()=> {
          this.intervalNum += 1;
          this.currentOption = this.chartOptions[this.intervalNum%this.chartOptions.length];
        }, 3200);
      }
    }
  },
  methods: {
    showIntro() {
      this.intervalNum = 0
      this.currentOption = this.chartOptions[this.intervalNum]
      this.intervalContainer = setInterval(()=> {
        this.intervalNum += 1;
        this.currentOption = this.chartOptions[this.intervalNum%this.chartOptions.length];
      }, 3200);
      this.showIntroBox = true
      toggleBody(1)
    },
    hideIntro() {
      this.showIntroBox = false
      clearInterval(this.intervalContainer)
      toggleBody(0)
    },
    changeIntervalNum(index){
      this.intervalNum = index
      this.currentOption = this.chartOptions[this.intervalNum]
    }
  }
}
</script>

<style lang="scss">
  .centerbg {
    height: 100vh;
    position: relative;

    background-color: #E6ECDA;
    overflow: hidden !important;
  }
  .home-title {
    background: linear-gradient(rgba(255, 255, 255, 0.75), rgba(255, 255, 255, 0.75)),url(@/assets/img/home_bg5_1.jpg);
    background-repeat: no-repeat;
    background-size: 100%; 
    height: 88px; width: 100%; 
    margin-top: 76px;

    h2 {
      line-height: 88px;
      font-size: 56px; 
      font-weight: 600;
      font-family: 'Courier New', Courier, monospace;
    }
  }
  .chart-display {
    // transition: opacity .25s ease;
    overflow: hidden;
    z-index: 9999;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    visibility: hidden;
    opacity: 0;
    backdrop-filter: blur(20px);
  }
  .chart-display.is-visible {
    visibility: visible;
    opacity: 1;
    animation: elastic .5s;
    background-color: rgba(255, 255, 255, 0.7);
  }
  .chart-display .intro-close {
    position: absolute;
    font-size: 48px;
    width: 52px;
    height: 52px;
    background: 0 0;
    top: 20px;
    right: 15px;
    cursor: pointer;
  }
  .chart-display .intro-text {
    position: absolute;
    font-size: 42px;
    font-weight: 600;
    font-family: 'Georgia', 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
    color:#41ab5d;
    top: 45px;
    left: 45px;
  }
  .chart-display .intro-process {
    position: absolute;
    bottom: 16px;
    left: 50%;
    width: 300px;
    transform: translateX(-150px);
    
    ul {
      padding: 0;
      display: flex;
      flex-direction: row;
      justify-content: center;
    }
    li {
      list-style: none;
      margin: 0 20px;
      font-size: 28px;
      cursor: pointer;
      color: #aaa;
      transition: all .5s ease;
    }
    li.activate {
      color: #41ab5d;
      transform: scale(1.2);
    }
  }
  .chart-display .intro-pause {
    position: absolute;
    bottom: 28px;
    right: 30px;
    width: 42px;
    height: 42px;
    color: #666;
    font-size: 42px;
    cursor: pointer;
    i {
      transition: all .5s ease;
      &:hover {
        color: #de2d26;
      }
    }
  }
  .display-intro {
    position: absolute;
    top: 108px;
    left: 50%;
    transform: translate(-500px, 0px); //x 192px
    width: 60px;
    height: 60px;
    margin-top: -30px;
    margin-left: -30px;
    font-size: 60px; 
    cursor: pointer;
    color: #41ab5d;
    transition: all .6s ease !important;
    border-radius: 100%;
  }
  .display-intro::after {
    animation: fx-plyr-play-button 1.65s ease-out infinite;
    border: 3px solid #41ab5d;
    border-radius: 150%;
    box-shadow: 0 0 10px #41ab5d;
    content: "";
    height: 140%;
    left: -12.3437px;
    position: absolute;
    top: 2.9px;
    width: 140%;
  }
  .display-intro:hover {
    color: #fb6a4a;
  }
  .display-intro:hover::after {
    border-color: #fb6a4a;
    box-shadow: 0 0 10px #fb6a4a;
  }
  // .img-display {
  //   margin-top: 15vh;
  // }
  .icon-box {
    display: flex; 
    justify-content: space-between; 
    flex-direction: column;
    margin-top: 30px
  }
  .icon-box .icon-box-row {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .statistic-icon {
    width: 150px;
    height: 125px;
    border-radius: 20px;
    padding: 15px;
    font-size: 24px;
    text-align: center;
    margin: auto;
    transition: .5s all ease;

    h5 {
      font-size:18px; 
      font-weight: 600; 
      line-height: 0px;
      transform: translateY(-30px);
    }

    span {
      font-size:18px!important; 
      font-weight: 600;
      color: white!important;
      transform: translateY(83px);
    }
  }
  #Species_statistic {
    background: url('@/assets/img/home_logo/Species.png');
    background-size:100% 100%;

    h5 {
      color: #6a51a3;
    }
  }
  #Datasets_statistic {
    background: url('@/assets/img/home_logo/Datasets.png');
    background-size:100% 100%;

    h5 {
      color: #7C5B89;
    }
  }
  #Experiments_statistic {
    background: url('@/assets/img/home_logo/Experiments.png');
    background-size:100% 100%;

    h5 {
      color: #BF9865;
    }
  }
  #Cells_statistic {
    background: url('@/assets/img/home_logo/Cells.png');
    background-size:100% 100%;

    h5 {
      color: #557A68;
    }
  }
  #Cell\ Types_statistic {
    background: url('@/assets/img/home_logo/CellTypes.png');
    background-size:100% 100%;

    h5 {
      color: #2D6F83;
    }
  }
  
  #Cell\ Markers_statistic {
    background: url('@/assets/img/home_logo/CellMarkers.png');
    background-size:100% 100%;

    h5 {
      color: #B4646F;
    }
  }
  .statistic-icon:hover {
    transform: scale(1.08);
    cursor: pointer;
    background: #666;
  }
  @keyframes fx-plyr-play-button {
  0% {
      -webkit-transform: scale(0.6);
      transform: scale(0.6)
  }

  to {
      opacity: 0
  }
}

</style>
